import React, {useState} from "react"
import { Icon, List, Form, Button } from 'semantic-ui-react';
import PropTypes from "prop-types";
import { useTextResources } from '../../../language';
import NumericInput from '../../shared/NumericInput';
import CurrencyInput from '../../shared/CurrencyInput';
import { Currencies } from '../../shared/currencies';
import './style.less';

const ShopItem = ({item, updateItems, price, currency}) => {
    const text = useTextResources()
    const [showItemExpanded, setShowItemExpanded] = useState()
    const [itemExpanded, setItemExpanded] = useState()
    const itemPrice = item.TransactionCodeHotelTaxes != null && item.TransactionCodeHotelTaxes.length > 0 ?
        item.AmountAfterTax :
        item.AmountBeforeTax
    const totalAmount = itemPrice * (item.Quantity || 1)

    const currencySymbol = Currencies[currency].symbol

    const toggleItemDisplay = async (e,item) => {
        if(showItemExpanded && itemExpanded && item.Id === itemExpanded){
            setShowItemExpanded(false)
            setItemExpanded(null)
        }
        else{
            setShowItemExpanded(true)
            setItemExpanded(item.Id)
        }
    }
    const toggelChosenItems = async (e, item, chosen) => {
        e.stopPropagation()
        if(chosen && item.Chosen){
            item.Quantity++;
        }
        else{
            item.Chosen = chosen
        }
        updateItems()
    }

    const updateQuantity = (quantity, item)=>{
        if(quantity == 0){
            item.Chosen = false
        }
        else{
            item.Quantity =  quantity
        }
        updateItems()
    }

    const updateAmountAfterTax = (amount, item)=>{
        if(item.TransactionCodeHotelTaxes != null && item.TransactionCodeHotelTaxes.length > 0){
            item.AmountAfterTax = amount
        }
        else{
            item.AmountBeforeTax = amount
        }
        updateItems()
    }

    
    return (
        <div key={item.Id}>
            <List.Item className={"shop-item-wrapper " + (item.Chosen ? "shop-item-active" : "")}>
                <div className="item-toggle-wrapper" onClick={(e) => toggleItemDisplay(e,item)}>
                    <Icon name={itemExpanded == item.Id ? "chevron down" : "chevron right"} color="grey"/>
                </div>
                <div className="shop-item-data" onClick={(e) => toggelChosenItems(e,item, true)}>
                    <div className="shop-item-name">
                        {item.Chosen ? <Icon name="checkmark" color="blue"/> : <Icon name="cart arrow down"/>}
                        <List.Content>{item.Name}</List.Content>
                    </div>
                    <div className="shop-item-price">
                        {itemPrice && !item.Chosen && <div  className="shop-item-price">{price(itemPrice, currency)}</div>}
                        {totalAmount && item.Chosen && 
                            <div  className="shop-item-summary">
                                <span>
                                    {text("Total")} {price(totalAmount, currency)}
                                </span>
                                <span>
                                    {text("Quantity")} {item.Quantity || 1}
                                </span>
                            </div>
                        }
                        {item.Chosen && <Icon name="trash" color="red" onClick={(e) => toggelChosenItems(e, item, false)}/>}
                    </div>
                    
                </div>
            </List.Item>     
            {itemExpanded == item.Id &&
                <Form className="shop-item-form">
                    <Form.Field inline 
                        className="shop-item-qty"
                        label={text("Quantity")} 
                        control={NumericInput} 
                        min={0} 
                        max={100}
                        value={item.Quantity}
                        digits={0}
                        onChange={value=>updateQuantity(value, item)}
                    />
                    <Form.Field inline 
                        label={text("Priceinctax")} 
                        control={CurrencyInput} 
                        currency={currencySymbol}
                        value={itemPrice} 
                        onChange={value=>updateAmountAfterTax(value, item)}
                    />
                    <div className="item-shop-summary">
                        <div className="shop-total">
                            <span className="total-title">{text("Total")}</span>
                            <span className="total-amount">
                                {price(itemPrice * item.Quantity, currency)}
                            </span>
                        </div>
                        <Button primary
                            disabled={item.Quantity === 0 || item.Chosen} 
                            onClick={(e) => toggelChosenItems(e, item, true)}>
                                {text("AddToCart")}
                        </Button>
                    </div>
                </Form>
            }
        </div>
    )
}

ShopItem.propTypes = {
    item: PropTypes.object,
    updateItems: PropTypes.func,
    price: PropTypes.func,
    currency: PropTypes.number
}

export default ShopItem;